import { useEffect, useRef } from 'react';

export const useResetSectionsAfterOnboardingTypeChange = ({
    isPersonalDataCompleted,
    resetPrecontractualDocsSection,
    resetEmailOTPSection,
    resetAccessDataSection,
    modifyPrecontractualDocsSection,
    formActions,
    onboardingType,
}) => {
    const isFirstRender = useRef(true);
    useEffect(() => {
        if (isFirstRender.current) {
            if (onboardingType) isFirstRender.current = false;
        } else {
            resetPrecontractualDocsSection();
            resetEmailOTPSection();
            resetAccessDataSection();
            formActions.reset('userProfile.email');
            formActions.reset('userProfile.password');
            isPersonalDataCompleted && modifyPrecontractualDocsSection();
        }
    }, [onboardingType]);
};
